import React from 'react';
import './App.css'; 

const Home = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.avif" alt="Logo"/>
        <p className="centered-paragraph">
        Turn any task into a race against time with Tymerao – the ultimate timer clock, countdown timer, and count up timer app. Set custom titles and icons for each event, and track time to your goals, deadlines, or daily routines in real-time. With Live Activities on your Lock Screen, Tymerao keeps your countdown clock visible at all times. Perfect as a personal timer, event timer app, stopwatch, or goal tracking app – stay focused, stay on track.
</p>

        <a href='https://apps.apple.com/app/id6748280537'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUs'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a> |
  <a href="mailto:devapp555@outlook.com?subject=Tymearo app" aria-label="Contact us via email" className="contact-button">Contact Us</a>

</div>
        </div>
        </>
     );
}
 
export default Home;